import React from 'react';
import PropTypes from 'prop-types';
import { Link as GatsbyLink, navigate } from 'gatsby';

export const Link = ({ children, to, absolute = false, onClick = null, ...rest }) => {
  const isInternal = /^\/(?!\/)/.test(to);
  let href = absolute ? `${process.env.GATSBY_APPLICATION_URL || ''}${to}` : to;

  const handleOnClick = (event) => {
    event.preventDefault();
    const [path, hash] = href.split('#');
    const queryParams = location.search;
    const currentHash = hash ? '#' + hash : '';
    if (queryParams) {
      const separator = href.includes('?') ? '&' : '?';
      href = `${path}${separator}${queryParams.substring(1)}${currentHash}`;
    }

    onClick?.();

    if (!absolute) {
      navigate(href);
    } else {
      window.location.href = href;
    }
  };

  const useInternalLink = isInternal && !absolute;

  return useInternalLink ? (
    <GatsbyLink to={href} onClick={handleOnClick} {...rest}>
      {children}
    </GatsbyLink>
  ) : (
    <a href={href} onClick={handleOnClick} {...rest}>
      {children}
    </a>
  );
};

Link.propTypes = {
  children: PropTypes.node.isRequired,
  to: PropTypes.string.isRequired,
  absolute: PropTypes.bool,
  onClick: PropTypes.func,
};
